export default function iframeSandboxDomainStrategy(metaSiteId, experiments) {
    var _a, _b;
    var iframeSandboxDomainParams = {};
    if (metaSiteId && ((_a = experiments === null || experiments === void 0 ? void 0 : experiments.useIframeSandboxDomain) === null || _a === void 0 ? void 0 : _a.enabled)) {
        var host = ((_b = experiments === null || experiments === void 0 ? void 0 : experiments.iframeSandboxSecondaryHost) === null || _b === void 0 ? void 0 : _b.enabled) ? 'usrfiles' : 'filesusr';
        iframeSandboxDomainParams.iframeSandboxDomain = "https://".concat(metaSiteId, ".").concat(host, ".com");
    }
    return iframeSandboxDomainParams;
}
//# sourceMappingURL=iframeSandboxDomainStrategy.js.map